// 工具接口为了方便构建全局state自定义方法    对数据的映射
const getters = {
  userInfo: state => state.UserInfo.userInfo,
  userPub: state => state.UserInfo.userPub,
  companyLevel: state => state.UserInfo.companyLevel,
  IMVisible: state => state.IMframe.IMVisible,
  IMframe: state => state.IMframe.IMframe,
  imFrameSrc: state => state.IMframe.imFrameSrc,
  loggedIn: state => !!state.UserInfo.userInfo.id, // 是否登录
  isSpecialty: state => state.Common.isSpecialty, // 犇犇专卖场开关
  honghongUserInfo: state => state.Honghong.honghongUserInfo, // 吽吽盒子应用用户信息
  honghongSign: state => state.Honghong.honghongSign, // 吽吽sign信息
  isConsole: state => state.Honghong.isConsole, // 是否显示控制台
  isNewPayType: state => state.UserInfo.isNewPayType
}

export default getters
